module.exports = __webpack_public_path__ + "img/noun-comment-305616-10.c56cffea.png";